import classNames from 'classnames'
import { useState } from 'react'
import generateRandomId from 'src/helpers/generate-random-id'
import { Typography } from 'src/modules/core/components/typography'
import type { BookingAnswersSectionProps } from './booking-answers-section.interface'
import classes from './booking-answers-section.module.scss'

export function BookingAnswersSection({ title, lines, className }: BookingAnswersSectionProps) {
  const [titleId] = useState(generateRandomId)
  if (!lines.length) return null

  return (
    <section className={classNames(classes.root, className)} aria-labelledby={titleId} data-testid="booking-answers">
      <Typography id={titleId} variant="body" className={classes.title}>
        {title}
      </Typography>
      <dl className={classes.list}>
        {lines.map((line, index) => (
          // Legacy lines have no question id and labels can repeat, so the position is the key.
          <div key={index} className={classes.item}>
            <dt className={classes.label}>{line.label}</dt>
            <dd className={classes.text}>{line.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
